import React, { ReactElement, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { SharingNewDropdown } from 'reactApp/components/SharingNew/Dropdown/SharingNewDropdown';
import { DOMAIN_ACCESS_OPTIONS, QA_VALUE, TOOLTIP_OFFSET } from 'reactApp/components/SharingNew/SharingNew.constants';
import { sendGa } from 'reactApp/components/SharingNew/SharingNew.helpers';
import { DomainAccess } from 'reactApp/components/SharingNew/SharingNew.types';
import styles from 'reactApp/components/SharingNew/Weblink/SharingNewWeblink.css';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { toggleWeblinkDomesticRequest } from 'reactApp/modules/modifying/modifying.actions';
import { Dropdown } from 'reactApp/ui/Dropdown/Dropdown';
import { DropdownMenu } from 'reactApp/ui/Dropdown/DropdownMenu';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

export const useDomestic = (item) => {
    const dispatch = useDispatch();
    const isPhone = EnvironmentSelectors.isPhone();
    const domainAccess = item?.weblinkDomestic ? DomainAccess.DOMESTIC : DomainAccess.EXTERNAL;
    const isFolder = item?.isFolder;

    const renderDomesticDropdown = useCallback(
        (onClick): ReactElement => {
            const list = Object.values(DOMAIN_ACCESS_OPTIONS).map((item) => ({
                id: item.id,
                text: item.text,
                check: item.id === domainAccess,
                qaValue: item.id,
            }));

            return <DropdownMenu list={list} theme="octavius" onClick={onClick} className={styles.dropdownMenu} />;
        },
        [domainAccess]
    );

    const handleUpdateDomestic = useCallback(
        (id): void => {
            if (id !== domainAccess) {
                sendGa('domestic');
                sendPaymentGa({
                    eventCategory: ECategoryGa.public,
                    action: 'edit-access',
                    type_for: id,
                    public_id: item?.weblink,
                });
                dispatch(toggleWeblinkDomesticRequest({ item }));
            }
        },
        [dispatch, domainAccess, item]
    );

    return useCallback((): ReactElement => {
        const item = DOMAIN_ACCESS_OPTIONS[domainAccess];

        return (
            <div className={styles.rightsItem} data-qa-item={QA_VALUE.domesticItem}>
                <span className={styles.rightsTitle}>{isFolder ? 'Папка доступна' : 'Файл доступен'}</span>
                <div className={styles.dropdown}>
                    <Dropdown
                        withinDialog
                        theme="octavius"
                        qaValue={item.id}
                        as={SharingNewDropdown}
                        value={isPhone ? item.text : item.text.toLowerCase()}
                        content={renderDomesticDropdown}
                        onClickItem={handleUpdateDomestic}
                        placement={tooltipPlacements.BOTTOM_LEFT}
                        qaValueContent={QA_VALUE.domesticDropdownContent}
                        tooltipOffset={TOOLTIP_OFFSET}
                        animatedTooltip
                        tooltipClassName={isPhone ? styles.tooltip : undefined}
                        isPhone={isPhone}
                    />
                </div>
            </div>
        );
    }, [domainAccess, handleUpdateDomestic, isFolder, isPhone, renderDomesticDropdown]);
};
